import React from 'react';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';

import styles from '../bannerModule.scss';
import IconArrowExtraSmallRight from '../../icons/icon_arrow_extra_small_right';
import DataStore from '../../../stores/DataStore';
import ShoesBannerHeader from '../../icons/shoes_banner_header';
import TabNavigationHelper from '../../../helper/tabNavigationHelper';

const ShoesBanner = inject('dataStore')(
    observer((props: { dataStore?: DataStore }) => {
        const tabNavigation = TabNavigationHelper.instance;
        const { dataStore } = props;

        if (!dataStore?.bannerModule.showShoes) {
            return null;
        }

        function getAltTagValue(): string {
            if(!dataStore)
                return '';
    
            return dataStore.mainStore.localization.generalL10n.safetyClassesOverview;
        }

        return (
            <a
                data-testid='shoes_banner'
                className={styles.banner_item}
                href={dataStore.bannerModule.shoesRedirectUrl}
                target='_blank'
                rel='noreferrer noopener'
                ref={(el) => tabNavigation.setFocusAtt(el)}
            >
                <div className={styles.header}>
                    <ShoesBannerHeader />
                    <p className={styles.header_banner_type}>
                        {dataStore.mainStore.localization.generalL10n.safetyClassesOverview}
                    </p>
                </div>
                <div className={classNames(styles.media_content, styles.media_content_shoes)} 
                    title={getAltTagValue()} />
                <div data-testid='shoes_button' className={styles.footer}>
                    <div className={styles.button}>
                        <div className={styles.title}>{dataStore.mainStore.localization.generalL10n.discoverNow}</div>
                        <IconArrowExtraSmallRight />
                    </div>
                </div>
            </a>
        );
    })
);

export default ShoesBanner;
